import React, { useCallback, useState } from 'react'
import Button from '../../ui/button'
import TextField from '../../ui/text-field'
import useShare from './useShare'

interface State {
    isLoading: boolean
    error?: string
    code: string
}

const initialState: State = { isLoading: false, code: "" }

interface FindGameFormProps {
    onFind?: (gameId: string) => any
}

export default function FindGameForm({ onFind }: FindGameFormProps) {
    const { getGameId } = useShare()
    const [state, setState] = useState(initialState)
    const disabled = state.isLoading || state.code.length < 6
    const handleCodeChange = useCallback(
        e => setState({ ...state, code: e.target.value.trim() }),
        [state]
    )
    const handleSubmit = useCallback(() => {
        setState({ ...state, isLoading: true })
        getGameId(state.code)
            .then(gameId => {
                setState({ ...state, isLoading: false })
                onFind && onFind(gameId)
            })
            .catch(() => setState({ ...state, isLoading: false }))
    }, [onFind, getGameId, state])

    return (
        <div>
            <TextField label="Game code" disabled={state.isLoading} onChange={handleCodeChange} />
            <Button variant={"outlined"} onClick={handleSubmit} disabled={disabled}>Join</Button>
        </div>
    )
}